
import _ from 'lodash';
import history from 'providers/history';
import React, { ReactNode } from 'react';
import Router from 'react-router';

import { BrandsInfoModel } from 'types/drupal/BrandInfo';

import BrandsInfoItem from 'components/pages/brand/BrandsInfoItem';

import BreadcrumbTrail from 'components/global/application/BreadcrumbTrail';

import FontAwesome from 'react-fontawesome';

import { Helmet } from 'react-helmet';

interface OwnProps {
    match: Router.match<{brand: string, model?: string}>;
}

export interface StateProps {
    brands: BrandsInfoModel[];
    fetchFailed: boolean;
    isMobile: boolean;
}

export interface DispatchProps {
    loadBrandsInfo(): void;
}

type CombinedProps = OwnProps & StateProps & DispatchProps;

class BrandsInfo extends React.Component<CombinedProps, {}> {

    constructor(props: CombinedProps) {
        super(props);
    }

    public componentDidMount () {
        this.props.loadBrandsInfo();
    }

    public componentDidUpdate(prevProps: CombinedProps) {
        if (this.props.fetchFailed) {
            history.push('/');
        }
    }

    public breadcrumbTrail = () => {
        const breadCrumbTrail =  [
            {
                label: 'Home',
                route: '/'
            },
            {
                label: 'Brands',
                route: '/brands/'
            },
        ];
        return breadCrumbTrail;
    }

    public helmet() {

        const title = 'Brands | Gruhn Guitars';
        const desc = 'Brands | Gruhn Guitars';
        return (
            <Helmet>
                <meta name="title" content={title}/>
                <meta name="description" content={desc} />
                <title>{title}</title>
            </Helmet>
        );
    }

    public render() {
        if (this.props.brands && this.props.brands.length <= 0) {
            return (<FontAwesome className="loading-spinner" name="spinner" size="3x" spin />);
        }

        return(
           <div className="brandsContainer">
               {this.helmet()}
                <div className="Results-breadcrumb"><BreadcrumbTrail pathNodes={this.breadcrumbTrail()} /></div>
                <div className="row">
                        { this.props.brands.map((brand, key) => {
                            return (
                                <BrandsInfoItem
                                    isMobile={this.props.isMobile}
                                    item={brand}
                                    className={this.props.isMobile ? 'col-12' : 'col-4'}
                                    key={key}
                                    showAsClickableImage={false}
                                />
                            );
                        })
                        }
                </div>
            </div>
        );
    }
}

export default BrandsInfo;



// WEBPACK FOOTER //
// ./src/components/pages/brand/BrandsInfo.tsx